
<div class="marunages-tabs">
  <div class="ui top attached tabular menu">
    <a class="active item" data-tab="marunages">まるなげ</a>
    <a class="item" data-tab="direct-calls">TEL</a>
  </div>

  <div class="ui bottom attached active tab segment" data-tab="marunages">
    <afadmin-marunages-index></afadmin-marunages-index>
  </div>
  <div class="ui bottom attached tab segment" data-tab="direct-calls">
    <afadmin-direct-calls></afadmin-direct-calls>
  </div>
</div>
